import _ from "lodash";

export function ordinaryDetailPageLink(routeBase: string, row: {id: number | undefined}): string | undefined {
    if (row) return `/${routeBase}/${row.id}`;
}

export const ordinaryDetailPageLinkTo = _.curry(ordinaryDetailPageLink);
